<script>
import { mapState, mapActions } from 'vuex';
/* components */
import FullScreenOverlay from '@/components/FullScreenOverlay';

/* tools */
import {} from '@/scripts/utils';

export default {
  name: 'CheckMail',
  components: {
    FullScreenOverlay,
  },
  props: {
    title: {
      type: String,
      default: 'Confirm Your Email',
    },
    subTitle: {
      type: String,
      default:
        'Your account has been successfully registered. To complete the process please check your email for a validation request.',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
  },
};
</script>

<template>
  <FullScreenOverlay>
    <div class="content">
      <div class="content__wrapper">
        <div class="content__title">{{ title }}</div>
        <div class="content__text">{{ subTitle }}</div>
      </div>
    </div>
  </FullScreenOverlay>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &__wrapper {
    max-width: 810px;
    position: relative;
    min-height: 315px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 20px;
      width: 25%;
      height: 50%;
      background-image: url('~@/assets/svg/shape-round.svg');
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      right: 20px;
      width: 25%;
      height: 50%;
      background-image: url('~@/assets/svg/shape-round.svg');
      transform: rotate(180deg);
    }
  }

  &__title {
    font-family: Sen-Bold;
    font-size: 36px;
    line-height: 43px;
    color: #ffd300;
    text-align: center;
    text-transform: uppercase;

    & + .content__text {
      margin-top: 15px;
    }
  }

  &__text {
    padding: 0 40px;
    margin-right: auto;
    text-align: center;
    font-family: Poppins-Light;
    font-size: 18px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.8);
  }
}

@media (max-width: $mobile) {
  .content {
    align-items: flex-start;
    margin-top: 30px;

    &__title {
      font-size: 24px;
      line-height: 29px;

      & + .content__text {
        margin-top: 20px;
      }
    }

    &__text {
      padding: 0;
      font-size: 14px;
      line-height: 1.93;
    }
    &__wrapper {
      min-height: auto;
      padding: 0;

      &:before,
      &:after {
        display: none;
      }
    }
  }
}
</style>
